import './index.scss';
import classnames from 'classnames';
import React from 'react';
import Menu from './menu';
import { useAppSidebar } from './provider';
import { MenuStates } from './provider/enums';
const AppSidebar = () => {
    const { activeRoute, isCollapsed } = useAppSidebar();
    const sidebarClass = classnames('app-sidebar', {
        collapsed: isCollapsed,
        'app-sidebar-popover': !activeRoute.includes(MenuStates.ProjectsWorkspace),
    });
    const navClass = classnames('nav', {
        collapsed: isCollapsed,
    });
    return (React.createElement("div", { className: sidebarClass },
        React.createElement("div", { className: navClass },
            React.createElement(Menu, null))));
};
export default AppSidebar;
